/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
Vue.component("axios", Axios)

Vue.config.devtools = true;
// Bootstrap
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import './bootstrap-override.scss'
import '@/styles/main.scss'

//i18n
import i18n from './i18n'

// Scrollmagic
import VueScrollmagic from 'vue-scrollmagic'
Vue.use(VueScrollmagic)



Vue.config.productionTip = false
export const EventBus = new Vue();

import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents,{
  disableClick: true,
  touchHoldTolerance: 20000
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
